import { useState, useCallback, useEffect } from "react";
import DataTable from '../DataTable/DataTable';
import { NotificationManager } from "react-notifications";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { convertDate } from "../AcitivityModal/assistingFunctions";
import accessReport from "../../apis/accessLogReport/accessReport";
import "./requisitionReports.css";
import config from "../../Config.json";
const stylesSX = {
  odd: {
    background: '#F6F6F6 !important',
  },
  even: {
    background: '#ffffff !important',
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
  waitingText: {
    marginLeft: '5px',
  },
};

const AccessReport = (props) => {
    const {
        userType,
        userIdType,
        userRecruitmentpartnerId,
        startSelectedDate,
        endSelectedDate,
        exports,
        additionalFilter,
        setTriggerAccess
    } = props;
    
    const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [dataResult, setDataResult] = useState([]);
    const [totalResult, setTotalResult] = useState(0);
    const [isSearching, setIsSearching] = useState(true);
    const [isExporting, setIsExporting] = useState(false);
    const [prevStartDate, setPrevStartDate] = useState(null);
    const [prevEndDate, setPrevEndDate] = useState(null);
    const [prevFilter, setPrevFilter] = useState({});

    // Define columns for the DataTable
    const columns = [
        {
            accessorKey: "displayName",
            header: "Name",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "displayEmail",
            header: "Email",
            width: "300px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "date",
            header: "Date",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Create_Group_List",
            header: "Create GroupList",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Create_Job",
            header: "Create Job",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Download_CV",
            header: "Download CV",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Interview_Activity",
            header: "Interview Activity",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Job_Search",
            header: "Job Search",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Manage_Team",
            header: "Manage Team",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Resource_Search",
            header: "Resource Search",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "run_report",
            header: "Run Report",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Save_Job",
            header: "Save Job",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Start_Activity",
            header: "Start Activity",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Submit_Activity",
            header: "Submit Activity",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Talent_Search",
            header: "Talent Search",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Update_Job_Users",
            header: "Update Job Users",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "Upload_Resume",
            header: "Upload Resume",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "user_login",
            header: "User Login",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "user_logout",
            header: "User Logout",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "View_Candidate",
            header: "View Candidate",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "View_Job",
            header: "View Job",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "ipAddresses",
            header: "IP Addresses",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => {
                const value = getValue();
                return Array.isArray(value) ? value.join(", ") : value || "";
            },
        },
        {
            accessorKey: "duration",
            header: "Duration",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "login_timeStamps",
            header: "Login Time",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => {
                const value = getValue();
                return Array.isArray(value) && value.length > 0 ? value[0] : value || "";
            },
        },
        {
            accessorKey: "logout_timeStamps",
            header: "Logout Time",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => {
                const value = getValue();
                return Array.isArray(value) && value.length > 0 ? value[0] : value || "";
            },
        },
    ];

    // Search function without debounce
    const performSearch = useCallback(async (
        userRecruitmentpartnerId,
        pageNumber,
        takeNumberOfResult,
        startSelectedDate,
        endSelectedDate,
        userId,
        additionalFilter
    ) => {
        try {
            setIsSearching(true);
            setDataResult([]);

            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const payload = {
                userRecruitmentpartnerId,
                page: pageNumber,
                size: takeNumberOfResult,
                formattedDatestart: convertDate(startSelectedDate),
                formattedDateend: convertDate(endSelectedDate),
                isExport: false,
                userId: userId,
                role: userType,
                timezone,
                additionalFilter
            };

            const search = await accessReport(payload);

            if (search?.totalCount?.[0]?.total >= 0) {
                const total = search.totalCount[0].total;
                const data = search.data;
                setDataResult(data);
                setTotalResult(total);
            } else {
                setDataResult([]);
                setTotalResult(0);
            }
            setIsSearching(false);
        } catch (error) {
            console.error("Error fetching access report:", error);
            setDataResult([]);
            setTotalResult(0);
            setIsSearching(false);
            NotificationManager.error("Failed to load data", "Error", 10000);
        }
    }, [userType]);

    // Handle page change
    const handlePageChange = (newPage, newPageSize) => {
        setPageNumber(newPage);
        if (newPageSize && newPageSize !== takeNumberOfResult) {
            setTakeNumberOfResult(newPageSize);
        }
    };

    // Handle page size change
    const handlePageSizeChange = (newPageSize) => {
        setTakeNumberOfResult(newPageSize);
        setPageNumber(1);
    };

    
    

    // Reset page if filter changes
    useEffect(() => {
        const datesChanged = prevStartDate !== startSelectedDate || prevEndDate !== endSelectedDate;
        const filtersChanged = JSON.stringify(prevFilter) !== JSON.stringify(additionalFilter);

        if (datesChanged || filtersChanged) {
            setPageNumber(1);
            setPrevStartDate(startSelectedDate);
            setPrevEndDate(endSelectedDate);
            setPrevFilter({ ...additionalFilter });
        }
    }, [additionalFilter, startSelectedDate, endSelectedDate, prevStartDate, prevEndDate, prevFilter]);

    useEffect(() => {
        const startDate = convertDate(startSelectedDate);
        const endDate = convertDate(endSelectedDate);

        if (!startSelectedDate || !endSelectedDate || startDate > endDate) {
            setDataResult([]);
            setTotalResult(0);
            NotificationManager.error("Please enter a valid date", "Error", 10000);
        } else {
            // When any dependency changes, schedule a search.
            setIsSearching(true);
            setDataResult([]);

            const timeoutId = setTimeout(() => {
                performSearch(
                    userRecruitmentpartnerId,
                    pageNumber,
                    takeNumberOfResult,
                    startSelectedDate,
                    endSelectedDate,
                    userIdType,
                    additionalFilter
                );
            }, 1000); // 1000ms debounce delay

            // Cleanup cancels the pending search if dependencies change quickly.
            return () => clearTimeout(timeoutId);
        }
    }, [pageNumber, takeNumberOfResult, startSelectedDate, endSelectedDate, additionalFilter, userRecruitmentpartnerId, userIdType, performSearch]);

    const callApiToGenerateExcel = useCallback(async () => {
        setIsExporting(true);
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const startDate = convertDate(startSelectedDate);
        const endDate = convertDate(endSelectedDate);

        let exportArr = [];
        let maxSize = config.MAX_SIZE ;
        let end = Math.ceil(totalResult / maxSize);
        let pageStart = 1;
        try {
            for (let start = 0; start < end; start++) {
                const payload = {
                    userRecruitmentpartnerId,
                    page: pageStart,
                    size: maxSize,
                    formattedDatestart: startDate,
                    formattedDateend: endDate,
                    isExport: true,
                    userId: userIdType,
                    role: userType,
                    additionalFilter,
                    timezone
                };
                const search = await accessReport(payload);

                search?.data.forEach((ele) => {
                    const ipAddress = ele.ipAddresses?.join(", ") || "";
                    const login_time = ele.login_timeStamps?.[0] || "";
                    const logout_time = ele.logout_timeStamps?.[0] || "";
                    
                    const newObj = {
                        "Name": ele.displayName || "",
                        "Email": ele.displayEmail || "",
                        "Date": ele.date || "",
                        "Create GroupList": ele.Create_Group_List || "",
                        "Create Job": ele.Create_Job || "",
                        "Download CV": ele.Download_CV || "",
                        "Interview Activity": ele.Interview_Activity || "",
                        "Job Search": ele.Job_Search || "",
                        "Manage Team": ele.Manage_Team || "",
                        "Resource Search": ele.Resource_Search || "",
                        "Run Report": ele.run_report || "",
                        "Save Job": ele.Save_Job || "",
                        "Start Activity": ele.Start_Activity || "",
                        "Submit Activity": ele.Submit_Activity || "",
                        "Talent Search": ele.Talent_Search || "",
                        "Update Job Users": ele.Update_Job_Users || "",
                        "Upload Resume": ele.Upload_Resume || "",
                        "User Login": ele.user_login || "",
                        "User Logout": ele.user_logout || "",
                        "View Candidate": ele.View_Candidate || "",
                        "View Job": ele.View_Job || "",
                        "IP Addresses": ipAddress,
                        "Duration": ele.duration || "",
                        "Login Time": login_time,
                        "Logout Time": logout_time
                    };

                    exportArr.push(newObj);
                });
                pageStart = pageStart + maxSize;
            }

            if (exportArr.length === 0) {
                NotificationManager.error("No data available", "Error", 10000);
                setTriggerAccess(false);
                setIsExporting(false);
                return;
            }
            // Lazy load XLSX only when needed for export
           const { utils, writeFile } = await import("xlsx");
            const ws = utils.json_to_sheet(exportArr);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Access Report");
            writeFile(wb, "Access_log_report.xlsx");

            setTriggerAccess(false);
            setIsExporting(false);
        } catch (error) {
            console.error("Error exporting:", error);
            NotificationManager.error("Failed to export", "Error", 10000);
            setIsExporting(false);
        }
    }, [totalResult, userRecruitmentpartnerId, startSelectedDate, endSelectedDate, userIdType, userType, additionalFilter, setTriggerAccess]);

    useEffect(() => {
        if (exports) {
            callApiToGenerateExcel();
        }
    }, [exports, callApiToGenerateExcel]);

    return (
        <>
            <Backdrop sx={stylesSX.backdrop} open={isExporting}>
                <CircularProgress color="inherit" />
                <Typography sx={stylesSX.waitingText}>Please wait...</Typography>
            </Backdrop>

            <DataTable
                data={dataResult}
                columns={columns}
                isLoading={isSearching}
                totalRecords={totalResult}
                currentPage={pageNumber}
                pageSize={takeNumberOfResult}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                enableFiltering={false} 
                enablePagination={true}
                enableSorting={false} 
                pageSizeOptions={[5, 10, 20, 50, 100]}
                isServerSide={true}
                className="kendo_reports"
                noDataText="No results found !"
            />
        </>
    );
};

export default AccessReport;
